<template>
  <div>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>Fundraising Kit</p>
      </v-card-title>
      <v-divider />
      <v-card-text class="ml-3">
        <v-list>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <p>
                  {{ $t("organization.details.fundraising_kit.title") }}
                </p>
              </v-list-item-title>
              <v-list-item-subtitle>{{
                $t("organization.details.fundraising_kit.description")
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="pr-10">
              <v-btn
                :disabled="isProLoading"
                color="#2661FF"
                height="35"
                class="rounded-lg"
                :loading="isStandardLoading"
                :outlined="isStandardLoading"
                @click="fundraisingKit('standard')"
              >
                <span class="white--text">{{ $t("general.import") }}</span>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item two-line class="mt-8">
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <p>
                  {{ $t("organization.details.fundraising_kit.title_pro") }}
                </p>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{
                  $t("organization.details.fundraising_kit.description_pro")
                }}</v-list-item-subtitle
              >
            </v-list-item-content>
            <v-list-item-action class="pr-10">
              <v-btn
                :disabled="isStandardLoading"
                color="#2661FF"
                height="35"
                class="rounded-lg"
                :loading="isProLoading"
                :outlined="isProLoading"
                @click="fundraisingKit('pro')"
              >
                <span class="white--text">{{ $t("general.import") }}</span>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <BaseInfoDialog
      v-if="infoDialog"
      :title="infoDialogTitle"
      :description="infoDialogDescription"
      :list="infoDialogList"
      closeText="Cerrar"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BaseInfoDialog from "@/components/BaseInfoDialog";

export default {
  name: "organizationFundraisingKit",
  components: {
    BaseInfoDialog
  },
  data() {
    return {
      isStandardLoading: false,
      isProLoading: false,
      infoDialog: false,
      infoDialogTitle: null,
      infoDialogDescription: null,
      infoDialogList: []
    };
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization
    })
  },
  methods: {
    ...mapActions({
      activateFundraisingKit: "organization/activateFundraisingKit"
    }),
    async fundraisingKit(type) {
      try {
        this.isStandardLoading = type === "standard" ? true : false;
        this.isProLoading = type === "pro" ? true : false;

        const organization_id = this.organization.id;

        const res = await this.activateFundraisingKit({
          organization_id,
          type
        });
        const results = res.data.importResults;

        //  {
        //   campaginKit: {
        //     campagin: false,
        //     campaignThanks: false,
        //     template: false,
        //     templateTranslations: false
        //   },
        //   formKit: {
        //     form: false,
        //     formLanguages: false,
        //     campaigns: false,
        //     countries: false,
        //     customFields: false,
        //     docs: false
        //   },
        //   templatesKit: {
        //     templates: false,
        //     templateTranslations: false
        //   },
        //   autoresponderKit: {
        //     autoresponder: false,
        //     attachments: false
        //   },
        //   landingKit: {
        //     landing: false,
        //     landingTranslations: false,
        //     landingNetworks: false,
        //     landingLinks: false
        //   }
        // };

        const resultsKeys = Object.keys(results);
        this.infoDialogTitle = "Fundraising Kit";
        this.infoDialogDescription = this.$t(
          "organization.details.fundraising_kit.success_import"
        );

        resultsKeys.forEach(result => {
          const fundraisingKitElement = results[result];
          const k = Object.keys(fundraisingKitElement);
          k.forEach(prop => {
            if (fundraisingKitElement[prop]) {
              this.infoDialogList.push(prop);
            }
          });
        });
        this.infoDialog = true;
        if (res.data.ok) {
          this.$noty.success("Fundraising Kit imported successfully");
        } else {
          throw Error;
        }
      } catch (error) {
        this.$noty.error("Error importing Landing Kit");
      } finally {
        this.isStandardLoading = false;
        this.isProLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
